import * as Yup from 'yup';
import Translator from '../../../services/translate-factory';
const validation = (T: Translator) =>
  Yup.object().shape({
    password: Yup.string().required(T.t('gen_cannot_leave_empty')),
    password_confirm: Yup.string()
      .required(T.t('gen_cannot_leave_empty'))
      .oneOf([Yup.ref('password'), null], T.t('gen_passwords_must_match')),
  });
export default validation;
